import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

const TeamActivityHero = () => (
  <Box 
    bg="#25575F" 
    minH="320px" 
    display="flex" 
    flexDirection="column" 
    alignItems="center" 
    justifyContent="center" 
    position="relative" 
    pb={12}
    bgImage="url('/png/career-header.png')"
    bgSize="contain"
    bgPosition="contain"
    bgRepeat="no-repeat"
  >
    <Heading
      as="h1"
      fontSize={{ base: '3xl', md: '5xl' }}
      color="#E6FF3F"
      fontWeight="bold"
      textAlign="center"
      mt={12}
    >
      Team Activity
    </Heading>
    <Text color="white" fontSize={{ base: 'lg', md: '2xl' }} mt={6} textAlign="center">
      Grow your abilities grow your career
    </Text>
  </Box>
);

export default TeamActivityHero; 